import LiteTooltip from './LiteTooltip';

export default LiteTooltip;
